import React from "react";
import ReactDOM from "react-dom";

class LoadingPanel extends React.PureComponent<{
  portal?: boolean;
  isLoading?: boolean;
}> {
  render(): React.JSX.Element | null {
    if (!this.props.isLoading) {
      return null;
    }
    const loadingPanel = (
      <div className="k-loading-mask">
        <span className="k-loading-text">Loading</span>
        <div className="k-loading-image" />
        <div className="k-loading-color" />
      </div>
    );

    const gridContent =
      this.props.portal !== false
        ? document && document.querySelector(".k-grid-content")
        : null;
    return gridContent
      ? ReactDOM.createPortal(loadingPanel, gridContent)
      : loadingPanel;
  }
}

export const PageLoadingPanel = () => {
  return (
    <div
      className="tlx-page-loading-mask"
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label="Page loading"
    >
      <div className="tlx-page-spinner-loader" aria-hidden="true"></div>
    </div>
  );
};

export default LoadingPanel;
